import { DialogActions as MuiDialogActions } from '@mui/material';

import { Button, type ButtonProps } from '../../atoms/Button';

const ACTIONS_LAYOUT = {
  flexDirection: { xs: 'column-reverse', sm: 'row' },
  alignItems: { xs: 'stretch', sm: 'center' },
  gap: 2,
  paddingX: 3,
  paddingBottom: 2,
} as const;

const TERTIARY_ACTION_LAYOUT = {
  ...ACTIONS_LAYOUT,
  '& > :first-of-type': {
    marginRight: { sm: 'auto' },
  },
} as const;

type DialogAction = Pick<ButtonProps, 'disabled' | 'loading' | 'onClick' | 'type'> & {
  label: string;
};

type DialogPrimaryAction = DialogAction & Pick<ButtonProps, 'color'>;

type Props = {
  primaryAction: DialogPrimaryAction;
} & (
  | { secondaryAction?: never; tertiaryAction?: never }
  | { secondaryAction: DialogAction; tertiaryAction?: DialogAction }
);

function renderAction(action: DialogAction, variant: ButtonProps['variant'], color?: ButtonProps['color']) {
  return (
    <Button
      variant={variant}
      color={color}
      type={action.type}
      disabled={action.disabled}
      loading={action.loading}
      onClick={action.onClick}
    >
      {action.label}
    </Button>
  );
}

export function DialogActions(props: Props) {
  const { primaryAction, secondaryAction, tertiaryAction } = props;

  return (
    <MuiDialogActions disableSpacing sx={tertiaryAction === undefined ? ACTIONS_LAYOUT : TERTIARY_ACTION_LAYOUT}>
      {tertiaryAction === undefined ? null : renderAction(tertiaryAction, 'text')}
      {secondaryAction === undefined ? null : renderAction(secondaryAction, 'outlined')}
      {renderAction(primaryAction, 'contained', primaryAction.color)}
    </MuiDialogActions>
  );
}

export type { DialogAction, Props as DialogActionsProps, DialogPrimaryAction };
